import { useGetCurrentSessionSupplantingQuery } from "./graphql/get-current-session-supplanting.v5.generated";
export var useSupplanting = function useSupplanting() {
  var _data$security$curren, _data$security$curren2, _data$security$curren3, _data$security$curren4, _data$security$curren5;
  var _useGetCurrentSession = useGetCurrentSessionSupplantingQuery({
      context: {
        clientName: 'v5'
      }
    }),
    data = _useGetCurrentSession.data;
  var isImpressionating = (data === null || data === void 0 ? void 0 : (_data$security$curren = data.security.current_session) === null || _data$security$curren === void 0 ? void 0 : _data$security$curren.session_type) === 'ImpersonatingJWTSession';
  var impresionatingUserIds = data === null || data === void 0 ? void 0 : (_data$security$curren2 = data.security.current_session) === null || _data$security$curren2 === void 0 ? void 0 : (_data$security$curren3 = _data$security$curren2.session_data) === null || _data$security$curren3 === void 0 ? void 0 : _data$security$curren3.impersonating_user_ids;
  var organizationId = data === null || data === void 0 ? void 0 : (_data$security$curren4 = data.security.current_session) === null || _data$security$curren4 === void 0 ? void 0 : (_data$security$curren5 = _data$security$curren4.session_data) === null || _data$security$curren5 === void 0 ? void 0 : _data$security$curren5.organization_id;

  /**
   * The first user of array is the main/root account
   */
  var mainUserId = impresionatingUserIds && (impresionatingUserIds === null || impresionatingUserIds === void 0 ? void 0 : impresionatingUserIds.length) > 0 ? impresionatingUserIds[0] : '';
  var restUsersMapping = impresionatingUserIds === null || impresionatingUserIds === void 0 ? void 0 : impresionatingUserIds.map(function (user) {
    return {
      user_id: user,
      organization_id: organizationId
    };
  });
  return {
    isSupplanting: isImpressionating,
    mainUserId: mainUserId,
    organizationId: organizationId,
    restUsersMapping: restUsersMapping
  };
};